module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"news-history":"Total news captured in the previous 6 months"},"pt":{"news-history":"Total de Notícias Capturadas nos 6 Meses Anteriores"},"es":{"news-history":"Total de noticias capturadas en los 6 meses anteriores"}}')
  delete Component.options._Ctor
}
